import axios from 'axios';
import * as types from './PersonalLogin.types';
import * as selectors from './PersonalLogin.selectors';
// import * as loginTypes from './../Login/Login.types';
import * as loginActions from './../Login/Login.actions';
import { showNotification } from './../../utils';

const apiUrl = process.env.REACT_APP_API_URL;

export const login = (type, signUpEmail = null, signUpPassword = null) => (dispatch, getState) => {
    const form = selectors.getForm(getState());
    let email = null;
    let password = null;

    if (signUpEmail != null) {
        email = signUpEmail;
        password = signUpPassword;
    } else {
        if (type === 5 && (form.email1 === '' || form.password1 === '')) {
            showNotification('Complete the information', 'Complete all the required fields of the form', 'info');
            return;
        } else if (type === 6 && (form.email2 === '' || form.password2 === '')) {
            showNotification('Complete the information', 'Complete all the required fields of the form', 'info');
            return;
        }
    
        if (type === 5) {
            email = form.email1;
            password = form.password1;
        } else if (type === 6) {
            email = form.email2;
            password = form.password2;
        }
    }

    dispatch({ type: types.LOGIN, payload: type });
    axios.post(apiUrl.replace('/v1', '') + '/oauth2/token',
        {
            grant_type: 'password',
            client_id: 'testclient',  // TODO: Add this to environment variables
            client_secret: 'testpass',  // TODO: Add this to environment variables
            username: email,
            password: password,
            loginType: 'uth-personal',
            loginCard: type,
        })
        .then(response => {
            dispatch({
                type: types.LOGIN_SUCCESS,
                payload: response.data
            });

            if (type === 5) {
                dispatch(loginActions.setPlatformType('utp'));
                dispatch(setLoggedType('utp'));
            } else if (type === 6) {
                dispatch(loginActions.setPlatformType('uth'));
                dispatch(setLoggedType('uth'));
            }

            dispatch(loginActions.setTokens(response.data, 'personal'));
            dispatch(setSignUp(null));
        })
        .catch(error => {
            dispatch({ type: types.LOGIN_ERROR, payload: null });
            showNotification('Incorrect Credentials', 'The email or password are incorrect', 'info');
        });
}

export const signUp = () => (dispatch, getState) => {
    const form = selectors.getForm(getState());
    const signUpType = selectors.getSignUpType(getState());
    if (form.name === '' || form.email === '' || form.confirmEmail === '' || form.password === '' || form.confirmPassword === '' || form.phone === '') {
        return showNotification('Complete the information', 'Complete all the required fields of the form', 'info');
    }
    if (form.email !== form.confirmEmail) {
        return showNotification('Email does not match', 'The Email and Confirm Email are different', 'info');
    }
    if (form.password !== form.confirmPassword) {
        return showNotification('Password does not match', 'The Password and Confirm Password are different', 'info');
    }

    dispatch({ type: types.SIGN_UP, payload: null });
    axios.post(apiUrl + '/uthealth-order/sign-up',
        {
            name: form.name,
            email: form.email,
            username: form.email,
            password: form.password,
            confirmPassword: form.confirmPassword,
            phone: form.phone,
            signUpType: signUpType,
        })
        .then(response => {
            dispatch({
                type: types.SIGN_UP_SUCCESS,
                payload: response.data
            });
            dispatch(login(signUpType, form.email, form.password));
        })
        .catch((error) => {
            dispatch({ type: types.SIGN_UP_ERROR, payload: null });
            if (error.response.status === 409) {
                showNotification('Duplicated user', 'The username or email selected is in use', 'info');
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const restorePassword = (type) => (dispatch, getState) => {
    const form = selectors.getForm(getState());

    if (type === 1 && form.email1 === '') {
        return showNotification('Complete the information', 'Enter your email to start the process of restore the password', 'info');
    }
    if (type === 2 && form.email2 === '') {
        return showNotification('Complete the information', 'Enter your email to start the process of restore the password', 'info');
    }

    let email = '';
    if (type === 1) {
        email = form.email1;
    } else {
        email = form.email2;
    }

    dispatch({ type: types.RESTORE_PASSWORD, payload: null });
    axios.post(apiUrl + '/uthealth-order/restore-password', { email: email })
        .then(response => {
            dispatch({ type: types.RESTORE_PASSWORD_SUCCESS, payload: null });
            showNotification('Instructions sent by email', 'An email has been sent to your email with instructions to restore your password', 'success');
        })
        .catch(error => {
            dispatch({ type: types.RESTORE_PASSWORD_ERROR, payload: null });
            showNotification('Error', 'An error has occurred', 'danger');
        });
}

export const setField = (name, value) => dispatch => {
    dispatch({
        type: types.SET_FIELD,
        payload: { name, value }
    });
}


export const setRedirect = (value) => dispatch => {
    dispatch({
        type: types.SET_REDIRECT,
        payload: value,
    });
}

export const setLoggedType = (value) => dispatch => {
    dispatch({
        type: types.SET_LOGGED_TYPE,
        payload: value,
    });
}

export const setSignUp = (value) => dispatch => {
    dispatch({
        type: types.SET_SIGN_UP,
        payload: value,
    });
}